import React from 'react';
import { Send, Loader2 } from 'lucide-react';

/**
 * Reusable message input component
 * @param {string} value - Current input value
 * @param {Function} onChange - Handler for input changes
 * @param {Function} onSend - Handler for sending message
 * @param {boolean} isSending - Whether message is being sent
 * @param {string} placeholder - Placeholder text
 * @param {boolean} disabled - Whether input is disabled
 * @param {string} inputType - 'input' or 'textarea' (default: 'input')
 */
const MessageInput = ({ 
  value, 
  onChange, 
  onSend, 
  isSending, 
  placeholder = 'Type your message...',
  disabled = false,
  inputType = 'input'
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className="flex gap-2">
      {inputType === 'textarea' ? (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled || isSending}
          rows={3}
          className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
        />
      ) : (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled || isSending}
          className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      )}
      <button
        onClick={onSend}
        disabled={!value.trim() || isSending || disabled}
        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        {isSending ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Send className="w-4 h-4" />
        )}
      </button>
    </div>
  );
};

export default MessageInput;

